import React from 'react';
import './RetailIntro.css';
import retailImg from '../../assets/images/retail.jpeg'; // Import image

const RetailIntro = () => {
  return (
    <section className="retail-intro-section">
      <div className="container">
        <div className="retail-intro-grid">
          <div className="retail-image-container">
            <img 
              src={retailImg} // Use imported image
              alt="Retail Industry" 
              className="retail-image"
            />
          </div>
          <div className="retail-text-content">
            <h2 className="retail-title">Why Choose NeuroverseAI?</h2>
            <p>
              SAP (Systems, Applications, and Products in Data Processing) provides a wide range of software solutions tailored for the retail industry to streamline operations, improve customer experiences, and drive growth. Here’s an overview of what SAP does in retail:
            </p>
            <h3 className="use-cases-title">Use Cases for SAP Process Automation</h3>
            <div className="use-cases-grid">
              <div className="use-case-card">
                <h4>Finance</h4>
                <p>Automating invoice validation and processing. Generating financial reports and audits.</p>
              </div>
              <div className="use-case-card">
                <h4>Human Resources</h4>
                <p>Onboarding processes for new hires. Managing employee requests (e.g., leave approvals, payroll adjustments).</p>
              </div>
              <div className="use-case-card">
                <h4>Supply Chain</h4>
                <p>Automating order confirmations and inventory updates. Optimizing logistics and delivery tracking.</p>
              </div>
              <div className="use-case-card">
                <h4>Customer Service</h4>
                <p>Automating ticket assignment and resolution workflows. Personalizing responses using AI.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RetailIntro;
